/*
 * offers translations for the "ar" locale.
 *
 * Split out of locales/ar.js so this feature's copy stops shipping to
 * every route in the app. See locales/our-offers/index.js.
 */
export default {
    main_tags: {
      title: "عروض كونتكت الحصرية | اكتشف أفضل العروض مع كونتكت ناو.",
      meta_desc:
        "اكتشف أحدث عروض حصرية بكل سهولة من خلال قسم العروض في تطبيق كونتكت ناو. اختار العرض المناسب ليك مع كونتكت في خطوات بسيطة واستمتع بتجربة سريعة ومريحة دلوقتي.",
      scripts: [
        {
          "@context": "https://schema.org",
          "@type": "Offer",
          name: "عروض كونتكت الحصرية | اكتشف أفضل العروض مع كونتكت ناو",
          description:
            "اكتشف أحدث عروض حصرية بكل سهولة من خلال قسم العروض في تطبيق كونتكت ناو. اختار العرض المناسب ليك مع كونتكت في خطوات بسيطة واستمتع بتجربة سريعة ومريحة دلوقتي.",
          url: "https://contact.eg/our-offers",
          seller: {
            "@type": "Organization",
            name: "Contact",
            url: "https://contact.eg/",
            logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/logo-ar.png",
          },
          areaServed: {
            "@type": "Country",
            name: "Egypt",
          },
          availability: "https://schema.org/InStock",
          category: "Financial Service",
          eligibleRegion: {
            "@type": "Country",
            name: "Egypt",
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "طلب التقسيط مع التاجر بياخد وقت قد ايه عشان يتوافق عليه ؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "أول ما بياناتك بتتراجع وتتأكد، هيوصلك رمز تأكيد (OTP)  على موبايلك علشان تكمل العملية. زيارتك لفرع التاجر وتقديم بيانات صحيحة بيساعدوا إن الإجراء يخلص أسرع.",
              },
            },
            {
              "@type": "Question",
              name: "هل ممكن أقدّم على أكتر من عرض في نفس الوقت؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "أيوه، تقدر تقدّم على أكتر من عرض بناءً على الحد الائتماني المتاح ليك. بس ادخل على قسم العروض، اختار العروض المناسبة ليك، وامشي على خطوات التقديم لكل عرض مباشرة من خلال  تطبيق كونتكت ناو.",
              },
            },
            {
              "@type": "Question",
              name: "إزاي تبقى عميل عند كونتكت و تحصل على عرض النهارده؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: `حمل تطبيق كونتكت ناو
افتح حسابك وكمّل تسجيلك. هيظهرلك الحد الائتماني المتاح لك فورا. لو اتقبلت، زور أقرب فرع كونتكت خلال 30 يوم علشان توقّع العقد. بعد التوقيع، هتبقي عميل كونتكت وتقدر تقدّم على العروض اللي انت عايزها
        `,
              },
            },
          ],
        },
      ],
    },
    valid_until: "صالح حتي ",
    to_know: "لمعرفة معلومات أكثر عن العرض سيب بياناتك",
    no_data: "لا يوجد عروض حاليا",

    hero_section: {
      title: "اكتشف عروض مميزة دلوقتي مع كونتكت",
      subtitle1:
        "في كونتكت، دايمًا بنهتم إن تجربتك معانا تكون سهلة وبسيطة ومريحة. تقدر تستكشف مجموعة كبيرة من العروض الحصرية من خلال قسم العروض على التطبيق، وتختار اللي يناسبك في كام خطوة بس.",
      subtitle2:
        "حمِّل تطبيق ContactNow دلوقتي واستمتع بتجربة سلسة ومريحة مع كل عرض بتختاره.",
      btn_download: "حمل الآن",
    },
    offers_steps: {
      title: " إزاي تقدّم على عرض؟",
      subtitle: "لو إنت عميل كونتكت بالفعل، اتبع الخطوات دي:",
      steps: [
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-1.png",
          content: "افتح تطبيق ContactNow.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-2-ar.webp",
          content:
            "ابحث عن التاجر اللي انت عايزه، أو ادخل على قسم العروض على طول.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-3-ar.webp",
          content: "اختار العرض اللي يناسبك.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-4-ar.png",
          content: "أدخِل البيانات المطلوبة.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-5-ar.webp",
          content: "لتاجر هيراجع بياناتك من خلال البوابة الخاصة بيه.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-6-ar.webp",
          content: "زور فرع التاجر واستنى موافقته.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-7.webp",
          content: "هيوصلّك رمز تأكيد (OTP) على موبايلك.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-8-ar.webp",
          content: "أول ما تأكد الرمز، العملية بتتم بنجاح.",
        },
      ],
    },

    faq: {
      title: "الاسئلة الشائعة ",
      items: [
        {
          q: "طلب التقسيط مع التاجر بياخد وقت قد ايه عشان يتوافق عليه ؟",
          a: `
        <p> أول ما بياناتك بتتراجع وتتأكد، هيوصلك رمز تأكيد (OTP)  على موبايلك علشان تكمل العملية. زيارتك لفرع التاجر وتقديم بيانات صحيحة بيساعدوا إن الإجراء يخلص أسرع.</p>
      `,
        },
        {
          q: "هل ممكن أقدّم على أكتر من عرض في نفس الوقت؟",
          a: `
     أيوه، تقدر تقدّم على أكتر من عرض بناءً على الحد الائتماني المتاح ليك. بس ادخل على قسم العروض، اختار العروض المناسبة ليك، وامشي على خطوات التقديم لكل عرض مباشرة من خلال  <a href="https://play.google.com/store/apps/details?id=eg.contact">تطبيق ContactNow</a>.</p>
          `,
        },
        {
          q: "إزاي تبقى عميل عند كونتكت و تحصل على عرض النهارده؟",
          a: `
        <ul style="margin-top: 10px;">
           <li>حمِّل <a href="https://play.google.com/store/apps/details?id=eg.contact">تطبيق ContactNow.</a></li>
           <li>افتح حسابك وكمّل تسجيلك.</li>
           <li>هيوصلك قرار بالحد الائتماني, مقبول أو مرفوض.</li>
           <li>لو اتقبلت، زور أقرب فرع كونتكت خلال 30 يوم علشان توقّع العقد.</li>
           <li>بعد التوقيع، هتبقي عميل كونتكت وتقدر تقدّم على العروض اللي انت عايزها.</li>
        </ul>
      `,
        },
      ],
    },
  };
